// loginPromise.js
'use strict';

/**
 * Login promise
 */
let loginPromiseResolver = null;

const createLoginPromise = () => {
  if (loginPromiseResolver) {
    loginPromiseResolver.reject(new Error('login cancel'));
  }

  loginPromiseResolver = Promise.withResolvers();

  return loginPromiseResolver.promise;
};

const resolveLogin = payload => {
  const resolver = loginPromiseResolver;
  loginPromiseResolver = null;

  resolver?.resolve(payload);
};

const rejectLogin = error => {
  const resolver = loginPromiseResolver;
  loginPromiseResolver = null;

  resolver?.reject(error);
};

export { createLoginPromise, resolveLogin, rejectLogin };
